export default __webpack_public_path__ + "static/media/free_code_camp.902e44e3.webp";